import common from "@/utils/common.js";

/**
 * 转义 元素的innerHTML内容即为转义后的字符
 * @param str
 * @returns {string}
 */
export const htmlEncode = (str) => {
    return str.replace(/(["'<>]|&(?:(amp|lt|gt|#39|nbsp|quot|#\d+);)?)/g, (a, b, c) =>
      c
        ? a
        : {
          '<': '&lt;',
          '&': '&amp;',
          '"': '&quot;',
          '>': '&gt;',
          "'": '&#39;'
        }[a]
    )
  }
  
  /**
   * 解析 元素的innerHTML内容即为转义后的字符
   * @param str
   * @returns {string}
   */
export const htmlDecode = (str) => {
    return str.replace(/&(amp|gt|lt|quot|#39|nbsp);/g, (a) => {
        return {
        "&lt;": "<",
        "&amp;": "&",
        "&quot;": '"',
        "&gt;": ">",
        "&#39;": "'",
        "&nbsp;": " ",
        }[a];
    });
}
/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
    let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie(name) {
    let reg = RegExp(name + '=([^;]+)');
    let arr = document.cookie.match(reg);
    if (arr) {
        return arr[1];
    } else {
        return '';
    }
};

/**
 * 删除cookie
 **/
function delCookie(name) {
    setCookie(name, null, -1);
};


function sendNotifyToAllShop(content,link=""){

 if(!content){
   return;
 }
 common.connect("/enterprise/Enterprise_shop/get_shop_list",{page:1,page_size:1000},(res)=>{
   let list = res.shop_list.data;
   let whos = [];

   whos = list.map((v)=>{
    return v.shop_id;
   });
   let userType = "all";

   common.connect("/enterprise/Enterprise_shop/get_shop_user_list",{whos,userType},(uL)=>{
     let persons = uL.map((v)=>{
          return v.id;
     });
     var parm = {
       content,
       whos:JSON.stringify(persons),
       link
     };

     common.connect("/enterprise/Enterprise_shop/notify_shop_user",parm,()=>{

     });

   })


 })

}

/**
 * 导出
 **/
export {
    timestampToTime,
    setStore,
    getStore,
    removeStore,
    setCookie,
    getCookie,
    delCookie,
    sendNotifyToAllShop,
}
